import React from 'react';
import { CommonSummaryInfoSubtitle } from 'src/components/EntityPage/CommonSummaryInfo/CommonSummaryInfo';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import removeOtherTraffic from 'src/components/BeaconV2Components/utils/removeOtherTraffic';
import KeywordsWithTrafficSplineChart from '../KeywordsWithTrafficSplineChart';
import { useAppSelector } from 'src/utils/Hooks';
import BeaconMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart';
import TotalTrafficGrid from '../TotalTrafficGrid';
import { useCreateRemoveRetailPriceRangeFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBaseMetricRequestBuilder';
import { TotalTrafficTopSection } from '../TotalTrafficTopSection';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Original total traffic page without any of the topics features enabled. Can be
 * deprecated after the new topics features are released.
 */
export const OriginalTotalTrafficPage = () => {
  const mainEntityType = useAppSelector((state) => state.entityService.mainEntity.type);
  const removeRetailPriceRangeFilters = useCreateRemoveRetailPriceRangeFilters();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <Flex gap="lg" flexDirection="column">
          <CommonSummaryInfoSubtitle title="Total Traffic" />
          <TotalTrafficTopSection />
        </Flex>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_TOTAL_TRAFFIC_COLUMN.name}
          chartName={CHART_NAMES.BEACON_TOTAL_TRAFFIC_COLUMN_CHART}
        >
          {mainEntityType === 'product' ? (
            <BeaconMetricColumnChart
              fieldName="totalClicks"
              indexName="traffic"
              useAdvancedSearchDataArgs={{
                requestBuilder: (builder) => builder.apply(removeOtherTraffic),
                fields: [{ name: 'totalClicks' }],
                groupByField: 'searchTerm'
              }}
              beaconChartWithLegendPropsBuilder={(props) => ({
                ...props,
                title: 'Total Traffic'
              })}
            />
          ) : (
            <BeaconDropdownMetricColumnChart
              fieldName="totalClicks"
              indexName={({ selectedDropdownId }) =>
                selectedDropdownId === 'searchTerm' ? 'traffic' : 'aggregated-traffic'
              }
              dropdownOptions={[
                {
                  id: 'searchTerm',
                  label: 'Keyword'
                },
                {
                  id: 'categoryId',
                  label: 'Category'
                },
                {
                  id: 'subCategoryId',
                  label: 'Subcategory'
                },
                {
                  id: 'brandId',
                  label: 'Brand'
                },
                {
                  id: 'stacklineSku',
                  label: 'Product'
                }
              ].filter((option) => !option.id.toLowerCase().startsWith(mainEntityType))}
              useAdvancedSearchDataArgs={{
                requestBuilder: (builder) => builder.apply(removeOtherTraffic).apply(removeRetailPriceRangeFilters())
              }}
              titlePrefix="Total Traffic by"
            />
          )}
        </ChartContextProvider>

        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_KEYWORDS_WITH_TRAFFIC.name}
          chartName={CHART_NAMES.BEACON_KEYWORDS_WITH_TRAFFIC_SPLINE}
        >
          <KeywordsWithTrafficSplineChart />
        </ChartContextProvider>
        <TotalTrafficGrid />
      </Flex>
    </BasePageContainer>
  );
};
